<div class="m-0 row justify-content-center bg-black h-100">
  <div class="bg-black desktop col-md-5 p-3 text-center flex-column align-items-center justify-content-center ">
    <img (click)="goTo()" class="link img-fluid relative" src="assets/icon.png" />
    </div>
  <div class="col-md-7 bg-image-1 curve">
    <router-outlet></router-outlet>
</div>
    <!-- <button class="mb-2 btn-block" mat-stroked-button color="primary" (click)="explore()" type="button">Explore</button> -->
</div>
